import { FC, ReactNode } from "react"
import {
  Tooltip as TooltipPrimative,
  TooltipTrigger,
  TooltipContent
} from "../ui"

type TooltipType = {
  children: ReactNode,
  message: string,
}
export const Tooltip: FC<TooltipType> = ({
  children,
  message,
}) => {

  return (
    <TooltipPrimative>
      <TooltipTrigger asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent>
        {message}
      </TooltipContent>
    </TooltipPrimative>
  )
}
